export const ABBTH_PRODUCT_KEYS = ['abbth-gci', 'abbth-gtl', 'abbth-ghs', 'abbth-dvghs'];
export const ABBTH_ONE_DEPENDENT_OPTION_KEY = 'abbth-ghs-emp-and-1-dep';
export const ABBTH_NO_COVERAGE_OPTION_KEYS = ['abbth_no_coverage'];

export const isAbbthProduct = (productKey) => ABBTH_PRODUCT_KEYS.includes(productKey);
export const hideZeroPrice = (productKey, price) =>
    isAbbthProduct(productKey) && price !== null && price !== undefined && Number(price) === 0;

export const isNoCoverage = (option) => ABBTH_NO_COVERAGE_OPTION_KEYS.includes(option?.optionKey);

export const getSingleDependentUpdates = ({coverages, dependentIds, selectedDependentId}) => (
    (dependentIds || []).reduce((updates, memberId) => {
        const coverage = coverages[memberId];
        if (!coverage) return updates;
        const current = coverage.options?.find(option => option.id === coverage.selectOption?.id);
        const desired = memberId === selectedDependentId
            ? (current && !isNoCoverage(current) ? current : coverage.options?.find(option => !isNoCoverage(option)))
            : coverage.options?.find(isNoCoverage);
        if (desired && desired.id !== current?.id) {
            updates.push({coverageId: coverage.id, optionId: desired.id, member: memberId});
        }
        return updates;
    }, [])
);

export const applySingleDependentCoverageSelection = async ({
    dependentIds, productId, selectedDependentId, loadCoverage, updateCoverage,
}) => {
    const coverages = {};
    for (const memberId of dependentIds) {
        coverages[memberId] = await loadCoverage(memberId, productId);
    }
    const selectedCoverage = coverages[selectedDependentId];
    if (!selectedCoverage?.options?.some(option => !isNoCoverage(option))) {
        throw new Error('No coverage option is available for the selected dependent.');
    }
    for (const memberId of dependentIds) {
        if (memberId !== selectedDependentId && coverages[memberId] &&
            !coverages[memberId].options?.some(isNoCoverage)) {
            throw new Error('No Coverage is unavailable for another dependent.');
        }
    }

    const updates = getSingleDependentUpdates({coverages, dependentIds, selectedDependentId});
    for (let index = 0; index < updates.length; index++) {
        await updateCoverage(updates[index], index < updates.length - 1);
    }
    return updates.length;
};
